import React, { useState } from 'react';
import Slider from '../../atoms/SliderInput';
import styles from './RatingSlider.module.css';

const RatingSlider = ({title, labels = ["Bad", "Good", "Amazing"], min = 0, max = 100,
                      step = 0.1, initialValue = 100, onValueChange }) => {
    const snapToClosest = (val) => {
        if (val <= 25) return 0;
        if (val <= 75) return 50;
        return 100;
    };

    const [value, setValue] = useState(initialValue);

    const handleSliderChange = (event) => {
        const newValue = Number(event.target.value);
        // onValueChange(newValue)
        setValue(newValue);
    };

    const handleSliderRelease = () => {
        const snappedValue = snapToClosest(value);

        const animateValue = (start, end, duration) => {
            const startTime = performance.now();

            const animate = (currentTime) => {
                const elapsedTime = currentTime - startTime;
                const progress = Math.min(elapsedTime / duration, 1); // Ограничиваем от 0 до 1
                const easedProgress = easeOutCubic(progress); // Плавное движение

                const currentValue = start + (end - start) * easedProgress;
                setValue(currentValue);

                if (progress < 1) {
                    requestAnimationFrame(animate);
                } else {
                    setValue(end); // Завершаем анимацию
                    if (onValueChange) onValueChange(end);
                }
            };

            requestAnimationFrame(animate);
        };

        // Плавная функция (ease-out)
        const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
        // const newSnappedValue = snappedValue === 0 ? snappedValue + 5 : snappedValue === 100 ? snappedValue - 5 : snappedValue
        animateValue(value, snappedValue, 500); // 300ms анимация
    };


    return (
        <div className={styles.container}>
            <p className={styles.title}>{title}</p>
            <Slider
                value={value}
                min={min}
                max={max}
                step={step}
                onChange={handleSliderChange}
                onMouseUp={handleSliderRelease}
                onTouchEnd={handleSliderRelease}
            />
            <div className={styles.labels}>
                {labels.map((label, index) => (
                    <span
                        style={{ marginLeft: index === 1 ? 20 : 0 }}
                        key={index}
                        className={`${styles.label}`}>
                        {label}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default RatingSlider;
